<template src="./pipe.html"></template>
<script>
export default {
    name: 'pipe',
    props: ['observations', 'isReport', 'totalDistance'],
    data() {
        return {
            convertedNodes: null,
            sessionID: null,
            pipeFlow: '',
            ready: false
        };
    },
	computed: {
        imagePath() {
            return window.path;
        },
        pipeNodes() {
            return this.$store.state.ObservationModule.PipeNodes;
        },
        reportSettings() {
            return this.$store.state.ReportsModule.ReportSettings;
        },
        otherReportSettings() {
            return this.$store.state.ReportsModule.ReportSettings.OtherActionSettings;
        },
        visibleFaultImages() {
            return this.$store.state.ReportsModule.FaultPictureCodes
                .filter((code) => code.isChecked)
                .map((code) => code.name);       
        },
        isReverseFlowDirGraph() {
            return this.reportSettings.OtherActionSettings.chkReverseFlowDirGraphic;
        },
        flowGraphicDownstream() {
            if (this.reportSettings.OtherActionSettings.chkMirrorPlotReport) {
                return this.pipeFlow !== 'Downstream' && this.reportSettings.ShowSettings.chkUseFlowGraphic
            }
            return this.pipeFlow === 'Downstream' && this.reportSettings.ShowSettings.chkUseFlowGraphic
        },
        flowGraphicUpstream() {
            if (this.reportSettings.OtherActionSettings.chkMirrorPlotReport) {
                return this.pipeFlow !== 'Upstream' && this.reportSettings.ShowSettings.chkUseFlowGraphic
            }
            return this.pipeFlow === 'Upstream' && this.reportSettings.ShowSettings.chkUseFlowGraphic
        }
	},
    watch: {
        otherReportSettings: {
            deep: true,
            handler(oldVal, newVal) {
                this.convertPipeNodeForDisplay();
            },
        },
        isReverseFlowDirGraph(newVal) {
            if (this.isReport) {
                if (this.pipeFlow === 'Downstream') {
                    this.pipeFlow = 'Upstream';
                }
                else if (this.pipeFlow === 'Upstream') {
                    this.pipeFlow = 'Downstream'
                }
            }
        }
    },
    methods: {
        convertPipeNodeForDisplay() {       
            let nodes = DMUtils.copy(this.pipeNodes);
            let converted = [];
            if (this.isReport) {
                if (this.pipeFlow === 'Upstream' && this.reportSettings.OtherActionSettings.chkReverseDistance) {
                    nodes.sort((a, b) => {
                        const minA = a.Observations.length ? Math.min(...a.Observations.map(x => x.Distance)) : 0;
                        const minB = b.Observations.length ? Math.min(...b.Observations.map(x => x.Distance)) : 0;
                        return minB - minA;
                    });

                }
                if (this.reportSettings.OtherActionSettings.chkSortByTime) {
                    nodes.sort((a, b) => {
                        const minA = a.Observations.length ? Math.min(...a.Observations.map(x => x.VideoPosition)) : 0;
                        const minB = b.Observations.length ? Math.min(...b.Observations.map(x => x.VideoPosition)) : 0;
                        return minA - minB;
                    });
                }
            }
            nodes.forEach((node) => {
                
                if (node.Observations.length === 0) {
                    let noFault = {};
                    noFault.FileName = 'Fault.svg';
                    converted.push(noFault);
                }
                node.Observations.forEach((obs) => {
                    if (this.isReport) {
                        if (this.pipeflow === 'Upstream' && this.reportSettings.OtherActionSettings.chkReverseDistance) {
                            obs.Distance = this.totalDistance - obs.Distance;
                            if (Number.isInteger(obs.Distance) === false) {
                                obs.Distance = obs.Distance.toFixed(1)
                            }
                        }
                    }
                    converted.push(obs);
                });
            });
            if (this.isReport) {
                if (this.reportSettings.OtherActionSettings.chkMirrorPlotReport) {
                    converted.reverse();
                }
            }
            this.convertedNodes = converted;
        },
        getPipeNodes() {
            return this.$store.dispatch('ObservationModule/getPipeNodes', this.sessionID)
        },
        calculateTimeStamp(videoPosition) {
            return app.calculateDisplayTimestamp(videoPosition);
        },
		getPipeNodeImage(node) {
            let cssClasses = 'pipe-image ';
            if (node.FileName === 'Fault.svg' || node.Severity === 0) {
                cssClasses += 'pipe-fault';
            } else {
                cssClasses += 'pipe-fault-' + node.Severity;
            }

            return cssClasses;
        },
        getReportPipeNodeClasses(node) {
            let cssClasses = 'pipe-image-report ';

            if (node.Severity && this.reportSettings.ShowSettings.chkUseWeightForSeverity) {
                let observation = this.observations.find((obs) => obs.ObservationID === node.ObservationID);
                let structWeight = observation.Fields.find((fld) => fld.LabelText === 'Structural Weight');
                let maintWeight = observation.Fields.find((fld) => fld.LabelText === 'Maintenance Weight');

                if (this.reportSettings.ShowSettings.chkShowSMColor) {
                    if (structWeight && parseInt(structWeight.Value) > 0) {
                        cssClasses += 'pipe-fault-struct-' + node.Severity;    
                    }

                    if (maintWeight && parseInt(maintWeight.Value) > 0) {
                        cssClasses += 'pipe-fault-maint-' + node.Severity;
                    }
                }
            }

            return cssClasses;
        },
        getReportTextForNode(node) {
            let observation = this.observations.find((obs) => obs.ObservationID === node.ObservationID);

            if (!observation) {
                return;
            }

            let textForNode = "";
            if (node.Distance !== '' && node.Distance !== null && this.reportSettings.ShowSettings.chkPlotShowDistance) {
                textForNode += `(${node.Distance}) `;
            }
            if (node.FaultCode && this.reportSettings.ShowSettings.chkPlotShowCode) {
                textForNode += `${node.FaultCode} `;
            }
            if (node.FaultName && this.reportSettings.ShowSettings.chkPlotShowObservationName) {
                textForNode += `- ${node.FaultName} `;
            }
            if (node.PictureNumber) {
                textForNode += `Photo Num: ${node.PictureNumber} `;
            }
            if (node.VideoPosition !== "" && node.VideoPosition !== null && this.reportSettings.ShowSettings.chkShowVCRTime) {
                let tapePosition = this.calculateTimeStamp(node.VideoPosition)
                textForNode += `<strong>Tape Pos: </strong> ${tapePosition} `;
            }       
            if (node.VideoPosition !== "" && node.VideoPosition !== null && this.reportSettings.ShowSettings.chkShowMPEGTime) {
                textForNode += `<strong>Mpeg Pos: </strong> ${node.VideoPosition} `;
            }

            observation.Fields.forEach((field) => {
                if (field.Value) {
                    if (field.Name === 'PipeID'
                        || field.Name === 'PipeNumber'
                        || field.Name === 'Size'
                        || field.Name === 'Continuous'
                    ) {
                        textForNode += `<strong>${field.LabelText}:</strong> ${field.Value} `
                    }

                    else if (field.Name === 'Percent' && field.Value > 0 && this.reportSettings.ShowSettings.chkPlotShowPercent) {
                        textForNode += `<strong>${field.LabelText}:</strong> ${field.Value} `
                    }         

                    else if (field.Name === 'AtFrom' && this.reportSettings.ShowSettings.chkPlotShowPosition) {
                        let startPosition = field.Value;
                        if (this.pipeFlow === 'Upstream' && this.reportSettings.OtherActionSettings.chkReverseClockPositions) {
                            if (startPosition) {
                                let from = parseInt(startPosition);
                                if (from !== NaN) {
                                    from  = 12 - from;
                                    startPosition = from;
                                }
                            } 
                        } 
                        textForNode += `<strong> Position From:</strong> ${startPosition} `
                    }

                    else if (field.Name === 'To' && this.reportSettings.ShowSettings.chkPlotShowPosition) {
                        let endPosition = field.Value;
                        if (this.pipeFlow === 'Upstream' && this.reportSettings.OtherActionSettings.chkReverseClockPositions) {
                            if (endPosition) {
                                let to = parseInt(endPosition);
                                if (to !== NaN) {
                                    to = 12 - to;                                              
                                    endPosition = to;
                                }   
                            }
                        }

                        textForNode += `<strong> To:</strong> ${endPosition} `
                    }

                    else if (field.Name === 'StructWeight' && field.Value > 0 && this.reportSettings.ShowSettings.chkPlotShowStructWeight) {
                        textForNode += `<strong>${field.LabelText}:</strong> ${field.Value} `
                    }

                    else if (field.Name === 'MaintWeight' && field.Value > 0 && this.reportSettings.ShowSettings.chkPlotShowMaintWeight) {
                        textForNode += `<strong>${field.LabelText}:</strong> ${field.Value} `
                    }

                    else if (field.Name === 'Severity' && field.Value > 0 && this.reportSettings.ShowSettings.chkPlotIndexShowSeverityIndex) {
                        textForNode += `<strong>${field.LabelText}:</strong> ${field.Value} `
                    }

                    else if (field.Name ==='Dim1' && this.reportSettings.ShowSettings.chkPlotShowVal1) {
                            textForNode += `<strong>${field.LabelText}:</strong> ${field.Value} `
                    }
                    else if (field.Name ==='Dim2' && this.reportSettings.ShowSettings.chkValue_2st_Dimension) {
                            textForNode += `<strong>${field.LabelText}:</strong> ${field.Value} `
                    }
                    else if (field.Name ==='Dim3' && this.reportSettings.ShowSettings.chkPlotShowVal3) {
                            textForNode += `<strong>${field.LabelText}:</strong> ${field.Value} `
                    }
                    else if (field.Name ==='Dim4' && this.reportSettings.ShowSettings.chkPlotShowVal4) {
                            textForNode += `<strong>${field.LabelText}:</strong> ${field.Value} `
                    }
                    else if (field.Name ==='Dim5' && this.reportSettings.ShowSettings.chkPlotShowVal5) {
                            textForNode += `<strong>${field.LabelText}:</strong> ${field.Value} `
                    }
                    else if (field.Name ==='Dim6' && this.reportSettings.ShowSettings.chkPlotShowVal6) {
                            textForNode += `<strong>${field.LabelText}:</strong> ${field.Value} `
                    }
                    else if (field.Name ==='Dim7' && this.reportSettings.ShowSettings.chkPlotShowVal7) {
                            textForNode += `<strong>${field.LabelText}:</strong> ${field.Value} `
                    }
                    else if (field.Name ==='Dim8' && this.reportSettings.ShowSettings.chkPlotShowVal8) {
                            textForNode += `<strong>${field.LabelText}:</strong> ${field.Value} `
                    }
                    else if (field.Name ==='Dim9' && this.reportSettings.ShowSettings.chkPlotShowVal9) {
                            textForNode += `<strong>${field.LabelText}:</strong> ${field.Value} `
                    }

                    else if (field.Name === 'Joint' || field.Name === 'Step') {
                        textForNode += `<strong>${field.LabelText}</strong> `
                    }
    
                    else if (field.Name === 'Remarks' && this.reportSettings.ShowSettings.chkShowObsRemarks) {
                        textForNode += `<strong>${field.LabelText}:</strong> ${field.Value} `
                    }       
                    
                }
            })

            if (this.visibleFaultImages.includes(observation.FaultName)) {
                    observation.Images.forEach((image, index) => {
                    textForNode += `
                        <p class="dm-margin-0">
                            <a href="${image.ImageUrl}" target="_blank" class="dm-color-white dm-pointer">Photo ${index + 1}</a>
                        </p>`;
                });
            }

            return textForNode;
        },
		getTextForNode(node) {
            return `(${node.Distance}) - ${node.FaultCode}`;
        },
		jumpToSpotInVideoByNode(node) {
            let timestamp = node.VideoPosition;
            document.getElementById('observationVideo').currentTime = timestamp;
			this.$store.commit('ObservationModule/setSelectedPipeNode', node);
        },
    },
    mounted() {
        this.sessionID = this.$route.query.id;
        this.getPipeNodes()
            .then(() => {
                this.convertPipeNodeForDisplay();
                this.pipeFlow = this.$store.state.ObservationModule.PipeFlow;
                if (!this.pipeFlow) {
                    this.pipeFlow = 'Downstream';
                }
                this.ready = true;
            });
    }
};
</script>
